import { tvpil } from '../compat/tvpil';
import { createMissingCategoryError } from '../errors';

import { fetchMostWatchedQuery } from './queries';
import { createMostWatched } from './utils';

type FetchMostWatchedArgs = {
  referenceId: string;
  userId: string;
};

export async function fetchMostWatched({ referenceId, userId }: FetchMostWatchedArgs) {
  const category = tvpil.categoryTreeItemsMap.get(referenceId);

  if (!category) {
    throw createMissingCategoryError();
  }

  const mostWatchedData = await fetchMostWatchedQuery({ userId });

  return createMostWatched({
    mostWatched: category.mostWatched,
    watchStats: mostWatchedData,
  });
}
